module.exports = __webpack_public_path__ + "static/content_2_5_eg-241650b1f0e19a9f82206c9124b7895f.png";